import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getFileName, mapDataToSerie } from '../utils';
import Chart from './chart';
import ValuesTable from './valuesTable';
import { idsTypeIds } from '../constants';

const ExperimentVariableContainer = ({ 
  idsField,
  variableType,
  variableName,
  variableDefinition,
  variableUnit,
  variableTimeDependent,
  groupedEntryData,
  showEmpty,
  idsTypeId,
  experimentInfo,
}) => {
  const { pulse, run, machine } = experimentInfo || {};

  const { t } = useTranslation();

  if (!variableTimeDependent) {
    const value = groupedEntryData[0]?.value;

    return (((value !== "") || showEmpty) &&
      <>
        <div>
          <p>{idsField}</p>
          <div>{t('variables_container_value_label')}:{' '}</div>
          <pre>{ value || t('variable_value_empty') }</pre>

        </div>
        <hr />
      </>
    );
  }

  const data = mapDataToSerie(groupedEntryData?.[0]);

  return (
    <>
      <Row>
        <Col md='6'>
          <span>{idsField}</span>
          <ValuesTable groupedEntryData={data} />
        </Col>
        { idsTypeId !== idsTypeIds.pedestal ? <Col md='6'>
          <Chart 
            data={data}
            title={variableName || idsField}
            description={variableDefinition}
            unit={variableUnit}
            titleAlignment='top' 
            width={519}
            height={260}
            fileName={getFileName(idsField, pulse, run, machine)}
          />
        </Col> : null }
      </Row>
      <hr />
    </>
  );
};

ExperimentVariableContainer.propTypes = {
  idsField: PropTypes.string.isRequired,
  experimentInfo: PropTypes.object,
  variableType: PropTypes.string.isRequired,
  variableName: PropTypes.string,
  variableDefinition: PropTypes.string,
  variableUnit: PropTypes.string,
  showEmpty: PropTypes.bool,
  variableTimeDependent: PropTypes.bool.isRequired,
  idsTypeId: PropTypes.string,
  groupedEntryData: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    time: PropTypes.any,
  })).isRequired
};

export default ExperimentVariableContainer;
